// console.log('process.env.NODE_ENV', process.env.NODE_ENV);
const HOST = process.env.NODE_ENV === "development" ? 'http://localhost:7099' : (process.env.REACT_APP_SERVER_URL || 'http://localhost:7099');
const API_PREFIX = 'api';

export const BASE_URL = `${HOST}/${API_PREFIX}`;

export const Post_addBranch = `${BASE_URL}/coworking/branches`;
export const Get_getBranches = `${BASE_URL}/coworking/branches`;
export const Get_getBranchById = (branchId) => `${BASE_URL}/coworking/branches/${branchId}`;
export const Put_updateBranch = (branchId) => `${BASE_URL}/coworking/branches/${branchId}`;
export const Delete_deleteBranch = (branchId) => `${BASE_URL}/coworking/branches/${branchId}`;

export const Post_GetCoordinates = `${BASE_URL}/utils/get-coordinates`;

export const Get_getBuildings = (branchId) => `${BASE_URL}/coworking/branches/${branchId}/buildings`;
export const Post_addBuilding = (branchId) => `${BASE_URL}/coworking/branches/${branchId}/buildings`;
export const Get_getBuildingById = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}`;
export const Put_updateBuilding = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}`;
export const Delete_deleteBuilding = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}`;

// ** ----------------------------------------------------------------------------------------------------- Floor routes
export const Get_getFloors = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}/floors`
export const Post_addFloor = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}/floors`
export const Get_getFloorById = (floorId) => `${BASE_URL}/coworking/floors/${floorId}`
export const Put_updateFloor = (floorId) => `${BASE_URL}/coworking/floors/${floorId}`
export const Delete_deleteFloor = (floorId) => `${BASE_URL}/coworking/floors/${floorId}`

// ** ----------------------------------------------------------------------------------------------------- Floor layout routes
export const Get_getBuildingFloorStack = (buildingId) => `${BASE_URL}/coworking/buildings/${buildingId}/floor-stack`;
export const Get_getFloorLayout = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/layout`;
export const Post_createFloorLayout = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/layout`;
export const Put_updateFloorLayout = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/layout`;
export const Post_publishFloorLayout = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/layout/publish`;
export const Delete_deleteFloorLayout = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/layout`;
export const Get_getFloorLayoutOccupancy = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/layout/occupancy`;
export const Get_getPlaceableEntities = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/layout/placeable-entities`;

// ** ----------------------------------------------------------------------------------------------------- Office routes
export const Get_getOffices = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/offices`;
export const Post_addOffice = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/offices`;
export const Get_getOfficeById = (officeId) => `${BASE_URL}/coworking/offices/${officeId}`;
export const Put_updateOffice = (officeId) => `${BASE_URL}/coworking/offices/${officeId}`;
export const Delete_deleteOffice = (officeId) => `${BASE_URL}/coworking/offices/${officeId}`;

// ** ----------------------------------------------------------------------------------------------------- Seat routes
export const Get_getSeats = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}/seats`;
export const Post_addSeat = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}/seats`;
export const Get_getSeatById = (seatId) => `${BASE_URL}/coworking/seats/${seatId}`;
export const Put_updateSeat = (seatId) => `${BASE_URL}/coworking/seats/${seatId}`;
export const Delete_deleteSeat = (seatId) => `${BASE_URL}/coworking/seats/${seatId}`;
export const Patch_updateSeatStatus = (seatId) => `${BASE_URL}/coworking/seats/${seatId}/status`;

// ** ----------------------------------------------------------------------------------------------------- Coworking routes
export const Get_getCoWorkingSpaces = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/spaces`;
export const Post_addCoWorkingSpace = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/spaces`;
export const Get_getCoWorkingSpaceById = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}`;
export const Put_updateCoworkingSpaces = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}`;
export const Delete_deleteCoworkingSpace = (spaceId) => `${BASE_URL}/coworking/spaces/${spaceId}`;

// ** ----------------------------------------------------------------------------------------------------- User routes
export const Get_getUsers = `${BASE_URL}/auth/users`;
export const Post_addUser = `${BASE_URL}/auth/users`;
export const Get_getUserById = (userId) => `${BASE_URL}/auth/users/${userId}`;
export const Put_updateUser = (userId) => `${BASE_URL}/auth/users/${userId}`;
export const Delete_deleteUser = (userId) => `${BASE_URL}/auth/users/${userId}`;
export const Post_loginUser = `${BASE_URL}/auth/login`;
export const Put_updateMeetingRoomQuota = (userId) => `${BASE_URL}/auth/users/${userId}/meeting-room-quota`;
export const Put_updateUserStatus = (userId) => `${BASE_URL}/auth/users/${userId}/login-status`;
export const Post_sendResetPasswordEmail = (userId) => `${BASE_URL}/auth/users/${userId}/send-reset-password-email`;

// ** ----------------------------------------------------------------------------------------------------- Booking routes
export const Get_getBookings = `${BASE_URL}/gig/reservations`;
export const Post_addBooking = `${BASE_URL}/gig/reservation`;
export const Get_getBookingById = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}`;
export const Put_updateBooking = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}`;
export const Delete_deleteBooking = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}`;
export const Patch_updateBookingStatus = (bookingId) => `${BASE_URL}/gig/reservation/${bookingId}/status`;
export const Get_getBookingsByContract = (contractId) => `${BASE_URL}/gig/reservation/contract/${contractId}`;
export const Get_getBookingsByUser = (userId) => `${BASE_URL}/gig/reservation/user/${userId}`;
export const Get_getBookingsBySeat = (seatId) => `${BASE_URL}/gig/reservation/seat/${seatId}`;


// ** ----------------------------------------------------------------------------------------------------- Contract routes
export const Get_getContracts = `${BASE_URL}/gig/contract`;
export const Post_addContract = `${BASE_URL}/gig/contract`;
export const Get_getContractById = (contractId) => `${BASE_URL}/gig/contract/${contractId}`;
export const Put_updateContract = (contractId) => `${BASE_URL}/gig/contract/${contractId}`;
export const Delete_deleteContract = (contractId) => `${BASE_URL}/gig/contract/${contractId}`;
export const Patch_updateContractStatus = (contractId) => `${BASE_URL}/gig/contract/${contractId}/status`;
export const Get_getUserContracts = (userId) => `${BASE_URL}/gig/contract/user/${userId}`;
export const Get_getUserOwnContracts = `${BASE_URL}/gig/my-contracts`;
export const Patch_updateContractWithCompletedBookings = (contractId) => `${BASE_URL}/gig/contract/${contractId}/terminate`;


// ** ----------------------------------------------------------------------------------------------------- Meeting room routes
export const Get_getMeetingRooms = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/meeting-rooms`;
export const Post_addMeetingRoom = (floorId) => `${BASE_URL}/coworking/floors/${floorId}/meeting-rooms`;
export const Get_getMeetingRoomById = (meetingRoomId) => `${BASE_URL}/coworking/meeting-rooms/${meetingRoomId}`;
export const Put_updateMeetingRoom = (meetingRoomId) => `${BASE_URL}/coworking/meeting-rooms/${meetingRoomId}`;
export const Delete_deleteMeetingRoom = (meetingRoomId) => `${BASE_URL}/coworking/meeting-rooms/${meetingRoomId}`;


// ** ----------------------------------------------------------------------------------------------------- Meeting room booking routes
export const Get_getMeetingRoomBookings = `${BASE_URL}/gig/booking/meeting-room`;
export const Post_addMeetingRoomBooking = `${BASE_URL}/gig/booking/meeting-room`;
export const Get_getMeetingRoomBookingById = (bookingId) => `${BASE_URL}/gig/booking/meeting-room/${bookingId}`;
export const Put_updateMeetingRoomBooking = (bookingId) => `${BASE_URL}/gig/booking/meeting-room/${bookingId}`;
export const Put_cancelMeetingRoomBooking = (bookingId) => `${BASE_URL}/gig/booking/meeting-room/${bookingId}/cancel`;
export const Post_addTeamMemberMeetingRoomBooking = `${BASE_URL}/gig/booking/team-member/meeting-room`;

// router.delete('/booking/meeting-room/:bookingId', verifyToken, deleteMeetingRoomBooking);

// ** ----------------------------------------------------------------------------------------------------- Stats routes
export const Get_getDashboardStats = `${BASE_URL}/stats`;
export const Post_refreshDashboardStats = `${BASE_URL}/stats/refresh`;
export const Get_getCustomerDashboardStats = `${BASE_URL}/stats/customer`;
export const Get_getTeamMemberDashboardStats = `${BASE_URL}/stats/team-member`;
export const Get_getRentBreakdown = `${BASE_URL}/stats/rent-breakdown`;
export const Get_getCustomersStats = `${BASE_URL}/stats/users`;


// ** ----------------------------------------------------------------------------------------------------- Lead routes
export const Get_getLeads = `${BASE_URL}/lead`
export const Post_addLead = `${BASE_URL}/lead`
export const Get_searchLeads = `${BASE_URL}/lead/search`
export const Get_getLeadsByRep = (repId) => `${BASE_URL}/lead/rep/${repId}`
export const Get_getLeadById = (leadId) => `${BASE_URL}/lead/${leadId}`
export const Put_updateLead = (leadId) => `${BASE_URL}/lead/${leadId}`
export const Delete_deleteLead = (leadId) => `${BASE_URL}/lead/${leadId}`
export const Post_addEngagement = (leadId) => `${BASE_URL}/lead/${leadId}/engagement`
export const Post_addTeamMemberByAdmin = `${BASE_URL}/auth/users/team-member-by-admin`

// ** ----------------------------------------------------------------------------------------------------- User group routes
export const Post_createUGroup = `${BASE_URL}/ugroup/`;
export const Get_getUGroups = `${BASE_URL}/ugroup/`;
export const Get_getUGroupById = (groupId) => `${BASE_URL}/ugroup/${groupId}`;
export const Put_updateUGroup = (groupId) => `${BASE_URL}/ugroup/${groupId}`;
export const Delete_deleteUGroup = (groupId) => `${BASE_URL}/ugroup/${groupId}`;
export const Post_addUserToUGroup = (groupId) => `${BASE_URL}/ugroup/${groupId}/users`;
export const Delete_removeUserFromUGroup = (groupId) => `${BASE_URL}/ugroup/${groupId}/users`;
export const Get_getUGroupByUserId = (userId) => `${BASE_URL}/ugroup/user/${userId}`;
export const Post_getUGroupByUrl = `${BASE_URL}/ugroup/url`;
export const Post_getUGroupByFunction = `${BASE_URL}/ugroup/function`;

// ** ----------------------------------------------------------------------------------------------------- Customer support routes
export const Post_createTicket = `${BASE_URL}/support/ticket`;
export const Get_getTickets = `${BASE_URL}/support/ticket`;
export const Get_getTicketById = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}`;
export const Put_updateTicket = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}`;
export const Delete_deleteTicket = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}`;
export const Get_getInteractions = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/interactions`;
export const Post_addInteraction = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/interactions`;
export const Post_acknowledgeResolution = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/acknowledge`;
export const Post_submitFeedback = (ticketId) => `${BASE_URL}/support/ticket/${ticketId}/feedback`;

export const Get_getAllTickets = `${BASE_URL}/support/admin/ticket`;
export const Get_getTicketDetails = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}`;
export const Put_updateTicketStatus = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}/status`;
export const Put_assignTicket = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}/assign`;
export const Post_createTicketByAdmin = `${BASE_URL}/support/admin/ticket/create`;
export const Put_updateTicketDueDate = (ticketId) => `${BASE_URL}/support/admin/ticket/${ticketId}/due-date`;

// ** ----------------------------------------------------------------------------------------------------- Day pass routes

export const Post_createDayPass = `${BASE_URL}/gig/day-pass/create`; // If you want customers to create their own
export const Get_getDayPasses = `${BASE_URL}/gig/day-pass`;
export const Get_getDayPassById = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}`;
export const Patch_approveDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/approve`;
export const Patch_checkInDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/checkin`;
export const Patch_checkOutDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/checkout`;
export const Patch_updateDayPassPaymentStatus = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/payment`;
export const Get_getDayPassesByDate = (date) => `${BASE_URL}/gig/day-pass/date/${date}`;
export const Get_getDayPassesByCustomerEmail = (email) => `${BASE_URL}/gig/day-pass/email/${email}`;
export const Get_getDayPassesByCustomerId = (customerId) => `${BASE_URL}/gig/day-pass/uid/${customerId}`;
export const Patch_cancelDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/cancel`;
export const Patch_extendDayPass = (dayPassId) => `${BASE_URL}/gig/day-pass/${dayPassId}/extend`;

// ** ----------------------------------------------------------------------------------------------------- Notification routes
export const Get_getUserNotifications = `${BASE_URL}/notification`;
export const Patch_markNotificationRead = (notificationId) => `${BASE_URL}/notification/${notificationId}/read`;